module.exports = {
  presentationApp: {
    labels: {
      video: "Video",
      file: "Dosya",
      fileTemplate: "Dosya sablonu",
      openMedia: "Tam ekran onizlemede ac",
      closeMedia: "Onizlemeyi kapat",
      fullscreenPreview: "Tam ekran onizleme"
    },
    cover: {
      kicker: "SMART-TEAM-DEV-PORTAL",
      title: "Kurumsal portal",
      lead: "Kurumsal uygulamalara, verilere ve servislere merkeziçe erişim sağlayan web platformı.",
      note:
        "Belge yönetimini, finansal modülleri, bankacılık API'lerini, SKUD'u, laboratuvar kayıtlarını, ulaşım izlemeyi ve AI asistanını tek arayüzde birleştirir. Kendi altyapısında dağıtılır.",
      alt: "Kurumsal portal ana ekrani",
      video: "portal ana ekrani ve calisma modullerinin genel gorunumu"
    },
    about: {
      kicker: "Platform",
      title: "Modüler mimariye sahip Node.js platformu",
      lead:
        "Sunucu: Node.js, ön yüz: React/Webpack. Her bölüm, kendi iş mantığına, yönlendirmesine ve API'sine sahip bağımsız bir modüldür. Tek kabukta 30'dan fazla uygulama.",
      items: [
        "modüler yapı: her uygulama bağımsız",
        "AD grupları üzerinden rol tabanlı erişim denetimi",
        "harici sistemlerle entegrasyon için REST API",
        "TypeScript yazım desteği, tek kod tabanı"
      ],
      primaryAlt: "Kurumsal portal mimarisi",
      secondaryAlt: "Kullanici calisma alani",
      mediaCaption: "",
      video: ""
    },
    roles: {
      kicker: "Erişim",
      title: "AD gruplarına dayalı rol modeli",
      lead:
        "Kullanılabilir uygulama ve verilerin kapsamı, Active Directory'ye bağlı kullanıcı rolü ile belirlenir. Rol yönetimi merkezileştirilmiştir ve kod değişikliği gerektirmez.",
      keyTitle: "",
      items: [
        "yoneticiler",
        "ofis calisanlari",
        "muhendisler ve teknik uzmanlar",
        "muhasebe",
        "IK ekipleri",
        "BT yoneticileri",
        "dis kullanicilar"
      ],
      mediaAlt: "Rol modeli ve kullanici erisimi",
      mediaCaption: "",
      video: "roller bazinda erisim ayrimina ornek"
    },
    tasks: {
      kicker: "İşlevsellik",
      title: "Platform tarafından karşılanan görevler",
      lead:
        "Platform temel iş akışlarını kapsar: belge yönetimi, finansal muhasebe, bankacılık işlemleri, laboratuvar verileri, izleme ve otomasyon.",
      items: [
        "erişim yönetimi (AD, RBAC)",
        "belge iş akışı",
        "bankacılık işlemleri ve ekstreler",
        "laboratuvar modülleri ve standartlar",
        "erişim kontrolü ve çalışma süresi",
        "ulaşım ve telemetri (FortMonitor)",
        "OpenAI API tabanlı AI asistanı",
        "denetim ve sistem günlüğü"
      ],
      mediaAlt: "Kurumsal portal ekosistemi",
      mediaCaption: "Foto: portal ekosistemi ve temel calisma alanlari",
      video: "ana surecler uzerinden kisa gecis"
    },
    workflow: {
      kicker: "İş akışı",
      title: "Tipik kullanıcı yolu",
      lead:
        "Tüm modüller tek bir navigasyon modeline uyar. Kullanıcı bir kez kimlik doğrulaması yapar ve tüm izinli uygulamalara yeniden giriş olmadan erişir.",
      steps: [
        { title: "kimlik doğrulama", text: "AD veya yerleşik kimlik doğrulama sistemi üzerinden giriş." },
        { title: "çalışma masası", text: "Mevcut modüller, bildirimler ve widget listesi." },
        { title: "modül", text: "İkon veya doğrudan bağlantı ile ilgili uygulamaya geçiş." },
        { title: "işlem", text: "Verilerle çalışma: belge, form, kart, tablo." },
        { title: "sonuç", text: "Sistemde durum, bildirim, rapor, dosya veya kayıt." }
      ],
      mediaAlt: "Portalde uygulama secimi senaryosu",
      mediaCaption: "Foto: calisma masasindan uygulamaya gecis",
      video: "kullanicinin girisden sonuca yolu",
      lineTitle: "Tipik senaryo:",
      lineText: "kimlik doğrulama → çalışma masası → modül → işlem → sonuç"
    },
    desktop: {
      kicker: "Çalışma masası",
      title: "Yapılandırılabilir başlangıç ekranı",
      lead:
        "İkon, widget ve bölümlerin düzeni kullanıcı rolüne göre oluşturulur. Kişisel yapılandırma, sunucu tarafı değişiklik gerektirmeden profil ayarları üzerinden yapılır.",
      items: [
        "kişisel ikon ve hızlı bağlantı seti",
        "güncel verili widget'lar",
        "role ve birime göre uyarlama",
        "ilgili işleve ulaşmak için minimum adım"
      ],
      alt: "Portalin tek dijital calisma masasi",
      video: "calisma masasini kullanici rolune gore ayarlama"
    },
    modules: [
      {
        id: "paperwork",
        number: "07",
        kicker: "Belge yönetimi",
        title: "Belgeler, kartlar ve ekler",
        lead:
          "İç belgeler oluşturmak, depolamak ve ortak düzenleme için tek arayüz. Muhatap, çalışan ve sözleşme kartlarına bağlantılı. Office Online üzerinden ortak düzenle.",
        bullets: [
          "belge oluşturma ve düzenle",
          "eklerin dosya depolarında saklanması",
          "ortak düzenle (Office Online)",
          "bağlantılar: belge — muhatap — sözleşme"
        ],
        image: "/img/presentation_app/logo_docs.png",
        alt: "Belgeler ve belge yonetimi bolumu",
        caption: "Foto: belge yonetimi bolumu ve belge kartlari",
        file: "/img/presentation_app/logo_docs.png",
        video: "kart, ekler ve bagli verilerle calisma"
      },
      {
        id: "contragents",
        number: "08",
        kicker: "Muhataplar",
        title: "Dış doğrulamalı partner kartları",
        lead:
          "Kontur.Focus ve DaData entegrasyonu: vergi numarasına göre otomatik bilgi doldurma, güvenilirlik kontrolü, yasal statü değişikliği takibi.",
        bullets: [
          "vergi numarasına göre otomatik bilgi doldurma (DaData API)",
          "Kontur.Focus veri tabanında doğrulama",
          "statü değişikliği bildirimleri",
          "belgeler ve bankacılık işlemleriyle bağlantı"
        ],
        image: "/img/presentation_app/logo_agents.png",
        alt: "Partner karti ve iletisim verileri",
        caption: "Foto: partner karti, bilgiler ve durumlar",
        file: "/img/presentation_app/logo_agents.png",
        video: "bilgileri kontrol etme ve partner kartini guncelleme"
      },
      {
        id: "finance",
        number: "09",
        kicker: "Finans ve bankacılık",
        title: "Banka ekstreleri ve 1C entegrasyonu",
        lead:
          "Sberbank, Tinkoff, VTB, Tochka, Alfa-Bank API'leri üzerinden ekstre içe aktarımı. İşlemlerin muhataplar ve sözleşmelerle eşleştirilmesi, 1C formatında dışa aktarım.",
        bullets: [
          "birden fazla banka API'sine bağlantı",
          "ekstrelerin otomatik içe aktarımı ve ayrıştırılması",
          "ödemelerin muhataplarla eşleştirilmesi",
          "1C formatında veri dışa aktarımı"
        ],
        image: "/img/presentation_app/logo_finance.png",
        alt: "Portal finans bolumu",
        caption: "Foto: odeme gunlugu ve isleme durumlari",
        file: "/img/presentation_app/logo_finance.png",
        video: "islemleri ice aktarma, mutabakat ve bagli verilere gecis"
      },
      {
        id: "laboratory",
        number: "10",
        kicker: "Laboratuvar modülleri",
        title: "Ekipman, yöntem ve rapor takibi",
        lead:
          "Laboratuvar faaliyetleri için özel blok: standart dizinleri, ekipman ve grup kayıtları, rapor şablonları, çalışan sertifikaları.",
        bullets: [
          "standart ve yöntem dizinleri",
          "ekipman ve teknik grup kayıtları",
          "rapor şablonları (Word/Excel)",
          "çalışan sertifikaları ve yetkilendirmeleri"
        ],
        image: "/img/presentation_app/logo_lab.png",
        alt: "Portal laboratuvar modulu",
        caption: "Foto: ekipman, yontemler ve rapor sablonlari",
        file: "/img/presentation_app/logo_lab.png",
        video: "test nesnesinden hazir rapora kadar yol"
      },
      {
        id: "skud",
        number: "11",
        kicker: "Erişim kontrol sistemi",
        title: "Erişim kontrol sistemi entegrasyonu",
        lead:
          "Erişim olaylarının otomatik toplanması: geçişler, vardiyalar, geç kalmalar. Sunucu taraflı işleme, devam ve ihlal raporları.",
        bullets: [
          "EKS'ten geçiş olaylarının içe aktarımı",
          "vardiya ve geç kalma takibi",
          "devam ve ihlal raporları",
          "İK verileriyle bağlantı"
        ],
        image: "/img/presentation_app/logo_skud.png",
        alt: "Gecis kontrolu ve calisma zamani modulu",
        caption: "Foto: gecis olay gunlugu ve devamlilik analitigi",
        file: "/img/presentation_app/logo_skud.png",
        video: "gecis olayi, vardiya ve devamlilik raporunu inceleme"
      },
      {
        id: "transport",
        number: "12",
        kicker: "Ulaşım",
        title: "Görev emirleri ve FortMonitor telemetrisi",
        lead:
          "Dijital ulaşım işlemleri: görev emirleri, rotalar, kilometre. FortMonitor API'sından alınan telemetri verileriyle çapraz kontrol.",
        bullets: [
          "araç ve görev emri kayıtları",
          "rotalar ve kilometre kontrolü",
          "FortMonitor API'sından telemetri",
          "belgelerin fiili hareketle karşılaştırılması"
        ],
        image: "/img/presentation_app/logo_car.png",
        alt: "Ulasim izleme ve hareket",
        caption: "Foto: ulasim, rotalar ve endustriyel izleme",
        file: "/img/presentation_app/logo_car.png",
        video: "gorev kagidini kilometre ve rota verileriyle eslestirme"
      },
      {
        id: "ai",
        number: "13",
        kicker: "AI asistanı",
        title: "OpenAI API tabanlı yerleşik sohbet",
        lead:
          "OpenAI (GPT-4) entegrasyonu: yüklenen dosyaları ve sistem günlüklerini analiz etme, kurumsal veriler hakkında doğal dilde soru yanıtlama.",
        bullets: [
          "OpenAI Chat Completions API bağlantısı",
          "yüklenen dosya ve belge analizi",
          "sistem günlüğü ve olay ayrıştırma",
          "kurumsal veriler üzerinde bağlamsal arama"
        ],
        image: "/img/presentation_app/logo_ai.png",
        alt: "AI yardimcisi arayuzu",
        caption: "Foto: ornek istek ve AI yardimcisi yaniti",
        file: "/img/presentation_app/logo_ai.png",
        video: "dosya, log veya kullanici sorusunu analiz etme"
      },
      {
        id: "security",
        number: "15",
        kicker: "Güvenlik",
        title: "Kimlik doğrulama, roller ve denetim",
        lead:
          "Active Directory (LDAP) üzerinden kimlik doğrulama, uygulama ve veri düzeyinde rol tabanlı erişim denetimi (RBAC), tam kullanıcı faaliyet günlüğü.",
        bullets: [
          "Active Directory entegrasyonu (LDAP)",
          "rol tabanlı erişim yönetimi (RBAC)",
          "tüm önemli işlemlerin denetim günlüğü",
          "role göre veri görünürlük kısıtlaması"
        ],
        image: "/img/presentation_app/dark_access.png",
        alt: "Roller, AD gruplari ve portalin kisisel calisma alani",
        caption: "Foto: roller, AD gruplari ve erisim kurallari",
        file: "/img/presentation_app/dark_access.png",
        video: "rol verme, yetki kontrolu ve denetim gunlugunu goruntuleme"
      },
      {
        id: "automation",
        number: "16",
        kicker: "Otomasyon",
        title: "Arka plan görevleri ve sistemler arası entegrasyonlar",
        lead:
          "Düzenli işlemler için görev zamanlayıcı: veri senkronizasyonu, kontroller, e-posta gönderimi. Entegrasyonlar REST API ve SOAP üzerinden gerçekleştirilir.",
        bullets: [
          "arka plan görev zamanlayıcı (cron görevleri)",
          "harici sistemler için REST API ve SOAP",
          "e-posta, Telegram, WhatsApp bildirimleri",
          "AD, 1C ve bankalarla otomatik senkronizasyon"
        ],
        integrations: ["AD", "1C", "bankalar", "Kontur.Focus", "DaData", "e-posta", "mesajlaşma", "EKS", "FortMonitor", "OpenAI"],
        image: "/img/presentation_app/dark_Integration.png",
        alt: "Portalin kurumsal servis entegrasyonlari",
        caption: "Foto: harici servisler ve kurumsal portal entegrasyonlari",
        file: "/img/presentation_app/dark_Integration.png",
        video: "senkronizasyon, kontroller, postalar ve veri guncellemeleri"
      }
    ],
    value: {
      kicker: "Özet",
      title: "Platform ne sağlar",
      lead:
        "Merkezi platform dağınık araç sayısını azaltır, süreçleri standartlaştırır ve operasyonel maliyetleri düşürür.",
      groups: [
        {
          title: "Kullanıcılar için",
          bullets: [
            "birden fazla ayrı sistem yerine tek arayüz",
            "daha az manuel ve tekrarlayan işlem",
            "ihtiyaç duyulan verilere hızlı erişim",
            "gerçek zamanlı bildirimler ve durumlar"
          ]
        },
        {
          title: "BT ve iş dünyası için",
          bullets: [
            "merkezi erişim yönetimi",
            "denetim yoluyla süreç şeffaflığı",
            "tüm modüller için tek kod tabanı",
            "yeni uygulamalar için hazır altyapı"
          ]
        }
      ],
      assetTitle: "Fayda ikonlari",
      assetText: "zorunlu ekran goruntusu olmadan",
      image: "/img/presentation_app/dark_value.png",
      imageAlt: "Kullanici ve sirket icin pratik deger",
      imageCaption: "Foto: portalin kullanici ve sirket icin pratik degeri",
      video: "kullanici ve sirket icin degerin kisa ozeti"
    },
    conclusion: {
      kicker: "Platform",
      title: "Ölçeklenebilir kurumsal sistem",
      lead:
        "30'dan fazla modül, harici servislerle 10'dan fazla entegrasyon, kendi altyapısında dağıtım. Mimari değişikliği gerektirmeden genişlemeye hazır platform.",
      bullets: [
        "tüm birimler için tek arayüz",
        "sıkı bağlantı olmayan modüler mimari",
        "entegrasyonlar: AD, 1C, bankalar, EKS, OpenAI",
        "denetim, günlükleme, rol tabanlı erişim kontrolü",
        "yeni entegrasyonlar için belgelenmiş API"
      ],
      alt: "Kurumsal portal ana ekrani",
      file: "/img/presentation_app/dark_portal.png",
      video: "portalin temel yetenekleri uzerinden final gecisi"
    }
  }
};
